/**
 * @title 전역적 변수 사용으로 유지보수를 위한 파일
 */

// 015 build version 확인용
export const APP_VERSION = '1.1.11v';

// 010 서비스 이용 금액
export const ARREO_SMS = '25';
export const ARREO_LMS = '50';
export const ARREO_MMS = '250';

// 015 Works 서비스 이용 금액
export const WORKS015_SMS = '9';
export const WORKS015_LMS = '27';
export const WORKS015_MMS = '54';

// 015 Works 프로모션
export const WORKS015_PROMO1 = '150'; // 매월 sms 무료 건수

// TODO - STT, TTS 가격 수정
export const WORKS015_STT = '0'; // 1 -> 2024/11/27 까지 해당 값 사용
export const WORKS015_TTS = '0'; // 100 -> 2024/11/27 까지 해당 값 사용
export const WORKS015_PUSH = '9'; // 문자 알림 단가

// 015 Works 이용권 금액
export const WORKS015_MONTHLY = '1100';
export const WORKS015_ANNUAL = '11000';

// 문의전화
export const ENQUIRY_PHONE = '015-8504-0006';

// 서비스 명칭
export const SERVICE_NAME = '015';
export const SERVICE_APP_NAME = '톡비서';

// 랜덤 색상 배열
export const PASTEL_COLORS = [
  '#9A5C6C', // 어두운 핑크
  '#6C8E7B', // 어두운 민트
  '#B6A0D3', // 어두운 라벤더
  '#C9A9D1', // 어두운 보라
  '#F1B6A0', // 어두운 복숭아
  '#C7D6A7', // 어두운 연두
  '#B19C85', // 어두운 베이지
  '#D0A9B5', // 어두운 장미색
  '#7D8696', // 어두운 청록
  '#A3B3C6', // 어두운 파란색
  '#F0A1C4', // 어두운 핑크-살구색
  '#B9D9B5', // 어두운 민트-그린
  '#5C6F74', // 어두운 청록
  '#E8A1D3', // 어두운 라벤더 핑크
  '#BBD0A5', // 어두운 연두-황록색
  '#9B8C7F', // 어두운 올리브
  '#D7B6B1', // 어두운 붉은 색
  '#F1D0A7', // 어두운 베이지-주황
  '#B0C7F2', // 어두운 파스텔 블루
  '#E2D5A1', // 어두운 연한 황금
  '#A8D6E0', // 어두운 민트-블루
  '#A6A9C2', // 어두운 청회색
  '#E3B4D4', // 어두운 라벤더-핑크
  '#AFD7C5', // 어두운 연두-민트
  '#D2B5E0', // 어두운 보라-핑크
  '#BBF4C4', // 어두운 연두-화이트
  '#D4A6C7', // 어두운 핑크-보라
  '#B2B8D8', // 어두운 라벤더-블루
  '#CF9DC7', // 어두운 라일락
  '#B7C8E1', // 어두운 파란색-민트
  '#9A8B92', // 어두운 보라-그레이
];

export const CONNECT_NUMBER = new Set([
  '01050450077',
  '01055348157',
  '01079195283',
  '01084561878',
  '01022705073',
  '01022289820',
  '01049467265',
  '01035447485',
  '01090163493',
  '01035455808',
  '01098457774',
  '01082146118',
  '01087528309',
  '01022477601',
  '01056610926',
  '01076564875',
  '01076706171',
  '01037243759',
  '01049987052',
  '01024880592',
  //   '01052409153',
  '01036611078',
  '01033371259',
  '01067873947',
  '01040134281',
  '01024858609',
  '01053676212',
  '01027594883',
  '01046004123',
  '01059120601',
  '01048727396',
  '01091568768',
  '01027690062',
  '01067208422',
  '01093784554',
  '01058541241',
  '01067669932',
  '01051061024',
]);
